import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { ipBlock, getIpBlock } from '../../actions/ipBlock';
// import {changeTabs} from '../../actions/changeTab';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { toastr } from 'react-redux-toastr';
import PDABaseClass from '../abstract';
import { MESSAGES } from '../../utils/strings';

import './ipblock-form.scss';

class IpBlockForm extends PDABaseClass {

  oldIps = [];

  constructor (props) {
    super(props);
    this.state = {
      ip_blocks: [],
      errorMessages: '',
      btnIsDisabled: true,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.rejectTags = this.rejectTags.bind(this);
    this.wpData = {
      isLicenseExpired: window.pda_gold_v3_data.is_license_expired,
    };
  }

  componentWillMount () {
    this.refreshData();
    const { postId } = this.props;
    this.props.getIpBlock(postId);
  }

  compareIpBlocksState (ip_blocks) {
    const tmp = ip_blocks.map(ip => Number.parseInt(ip.split('.').join(''))).
      sort();
    return tmp.length === this.oldIps.length &&
      tmp.every(t => this.oldIps.includes(t));
  }

  handleChange (ip_blocks) {
    const errorMessages = '';
    const btnIsDisabled = this.compareIpBlocksState(ip_blocks);
    this.setState(prevState => ({
      ...prevState,
      ip_blocks,
      errorMessages,
      btnIsDisabled,
    }));
  }

  refreshData () {
    const { getIpBlock, postId } = this.props;
    this.showLoading();
    getIpBlock(postId).then(() => {
      const { iPBlockData } = this.props;
      this.setState(prevState => ({
        ...prevState,
        loadingData: false,
        ip_blocks: iPBlockData.ip_block,
      }));
      this.oldIps = iPBlockData.ip_block.map(
        ip => Number.parseInt(ip.split('.').join(''))).sort();
    });
  }

  render () {
    const { handleSubmit } = this.props;
    return (
      <div className="pda_form">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <div className="ip-block">
            <label>Blacklist these IP addresses: stop the following IP addresses
              from accessing private download links</label>
          </div>
          <div className="errors">
            {this.state.errorMessages}
          </div>
          <TagsInput value={this.state.ip_blocks} name="ip_block"
                     validationRegex={/^((?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d|\*)(\.|$)){4})|(([0-9a-f]|:){1,4}(:([0-9a-f]{0,4})*){1,7})$/}
                     onChange={this.handleChange}
                     onValidationReject={this.rejectTags}
                     addOnBlur={true}
                     inputProps={{ placeholder: 'Add an IP address' }}
          />
          <small>Use the asterisk (*) for wildcard matching. E.g: 7.7.7.* will
            match IP from 7.7.7.0 to 7.7.7.255
          </small>
          <div className="actions">
            <button disabled={this.state.btnIsDisabled ||
            this.wpData.isLicenseExpired} className="btn button action"
                    type="submit">Submit
            </button>
          </div>
        </form>
      </div>
    );
  }

  onSubmit (values) {
    const { ipBlock, postId } = this.props;
    values.ip_block = this.state.ip_blocks.join(';');
    ipBlock(postId, values).then(() => {
      toastr.success(MESSAGES.UPDATE_IP_BLOCK_OK);
    });
  }

  rejectTags (invalidIps) {
    let errorMessages = '';
    let btnIsDisabled = false;
    if (invalidIps.join(';')) {
      errorMessages = `You have entered an invalid IP address!`;
      btnIsDisabled = true;
    } else {
      btnIsDisabled = this.compareIpBlocksState(this.state.ip_blocks);
    }
    this.setState(prevState => ({
      ...prevState,
      errorMessages,
      btnIsDisabled,
    }));
  }
}

const Form = reduxForm({
  form: 'IpBlockForm',  // a unique identifier for this form
})(IpBlockForm);

const mapStateToProps = state => {
  return {
    iPBlockData: state.iPBlockData,
  };
};

const mapActionsToProps = (dispatch) => {
  return bindActionCreators({ getIpBlock, ipBlock }, dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(Form);
